import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { toast } from 'react-toastify';

// STYLES
import * as E from 'js/components/DesignSystem/Table/styles';
import { ButtonDelete } from './styles';

// COMPONENTES
import InputFields from './InputFields';
import View from './View';

// ICONES
import DeleteIcon from '@mui/icons-material/Delete';

// APIS E SERVICES
import { cellPhoneMask, cpfMask, maskCnpj } from 'js/library/utils/helpers';
import { uploadFiles } from 'js/library/utils/API/apiUploadFiles';
import { getUsersByFile } from 'js/library/utils/API/Posts/Notifications/getUsersByFile';
import { createMotherNotification } from 'js/library/utils/API/Posts/Notifications/createMotherNotification';
import { downloadImage, downloadImageAsBlob } from 'js/library/services/StorageManager';
import services from './services';

export default function SendNotification(props) {
  const history = useHistory();
  const postId = props.location.state.postId;
  const partnerId = localStorage.getItem('partnerIdClube');
  const establishmentId = props.match.params.id;

  // contém a informação se é estabelecimento ou clube
  const origin = localStorage.getItem('origin');

  const [loadingButton, setLoadingButton] = useState(false);
  const [loadingValidateUserMapfre, setLoadingValidateUserMapfre] = useState(true);

  const [cellPhone, setCellPhone] = useState('');
  const [cpf, setCpf] = useState('');
  const [cnpj, setCnpj] = useState('');
  const [email, setEmail] = useState('');

  const [searchTerm, setSearchTerm] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [checkboxMessage, setCheckboxMessage] = useState('');

  const [clubKey, setClubKey] = useState('');
  const [token, setToken] = useState('');
  const [verifyEmail, setVerifyEmail] = useState(false);

  // arquivo
  const [file, setFile] = useState(null);
  const [arrayDataToTxt, setArrayDataToTxt] = useState(null);

  // dados da tabela
  const [data, setData] = useState([]);
  const [filteredResults, setFilteredResults] = useState([]);
  const [dataUsers, setDataUsers] = useState({
    key: '',
    name: '',
    uId: '',
  });

  const [checkedItems, setCheckedItems] = useState({
    item1: false,
    item2: false,
  });

  const [form, setForm] = useState({
    notificationDate: null,
    title: '',
    message: '',
    partnerIdList: [],
  });

  const column = [
    { heading: origin === 'club' ? 'Chave do clube' : 'Celular do usuário', value: 'key' },
    { heading: 'Uid', value: 'uId' },
    { heading: 'Usuário que pode ver a notificação', value: 'name' },
  ];

  useEffect(() => {
    if (origin === 'establishment') {
      setClubKey('');
    }
  }, [origin]);

  useEffect(() => {
    if (partnerId !== '-Kx8jpgL7X-e_aJf0R7B-ClubMapfre') {
      setLoadingValidateUserMapfre(false);
    }

    if (partnerId === '-Kx8jpgL7X-e_aJf0R7B-ClubMapfre' && token?.length < 11) {
      setLoadingValidateUserMapfre(true);
    }
  }, [partnerId, token]);

  useEffect(() => {
    // se o clubKey estiver vazio, buscar o token
    if (origin === 'club' && clubKey) {
      // caso seja clubmapfre
      if (partnerId === '-Kx8jpgL7X-e_aJf0R7B-ClubMapfre' && token?.length === 11) {
        services.getUserClubMapfre(token, partnerId, setDataUsers, setLoadingValidateUserMapfre);
      } else {
        // para saber se o usuário pertence ao clube
        services.getUsersPartner(partnerId, clubKey, setDataUsers);
      }
    } else if (origin === 'establishment') {
      // para saber se o usuário pertence ao estabelecimento
      services.getClients(establishmentId, setDataUsers);
    } else {
      // seta o token do clube
      services.getClubToken(partnerId, setClubKey);
    }
  }, [origin, partnerId, clubKey, token?.length === 11]);

  // se algum dos textFields mudar, limpa a mensagem de erro
  useEffect(() => {
    setErrorMessage('');
  }, [cellPhone, cpf, cnpj, email]);

  useEffect(() => {
    // limpa o state data sempre que a opção: lista de usuário direcionada for false, e limpa o textField
    if (!checkedItems.item2) {
      setData([]);
      setCellPhone('');
      setCpf('');
      setCnpj('');
      setEmail('');
    }

    // limpa a mensagem de erro se o usuário marcar um dos checkbox
    if (checkedItems.item1 || checkedItems.item2) {
      setCheckboxMessage('');
    }
  }, [checkedItems]);

  // removendo a máscara e adicionando +55
  const removeMask = (value) => value.replace(/\D/g, ''); // remove qualquer caractere que não seja número
  const formatPhoneNumber = (phone) => {
    const cleanPhone = removeMask(phone);
    return `+55${cleanPhone}`;
  };

  useEffect(() => {
    const tokenMap = {
      cellPhone: formatPhoneNumber(cellPhone),
      cpf: removeMask(cpf),
      cnpj: removeMask(cnpj),
      email: email,
    };

    // atualiza o token sem a máscara e com +55 para celular
    setToken(tokenMap[clubKey]);
  }, [clubKey, cellPhone, cpf, cnpj, email]);

  const validateEmail = (email) => {
    if (!email) {
      setVerifyEmail(false); // email vazio = inválido
      return false;
    }

    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    const isValid = emailRegex.test(email);
    setVerifyEmail(isValid);
    return isValid;
  };

  useEffect(() => {
    if (data.length > 0) {
      // seta o array data no state filteredResults
      setFilteredResults(data);

      // transforma o array data em um txt
      const keys = data.map((user) => user.key).join('\n');
      const blob = new Blob([keys], { type: 'text/plain' });
      const fileAsTxt = new File([blob], 'usuarios.txt', { type: 'text/plain' });
      setArrayDataToTxt(fileAsTxt);
    } else {
      setFile(null);
    }
  }, [data]);

  // para verificar e remover duplicados quando o state data for atualizado
  useEffect(() => {
    if (data.length > 0) {
      // cria um conjunto para rastrear chaves únicas
      const uniquePhoneNumbers = new Set();
      // filtra os dados para manter apenas chaves únicas
      const filteredData = data.filter((item) => {
        if (!uniquePhoneNumbers.has(item.key)) {
          uniquePhoneNumbers.add(item.key);
          return true;
        }
        return false;
      });
      // verifica se houve alteração nos dados antes de atualizar o state data
      if (filteredData.length !== data.length) {
        setData(filteredData);
      }
    }
  }, [data]);

  // sobe o arquivo com a lista de usuários para a pasta 'post-users-uid' em storage (firebase)
  const uploadingFile = (file) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();

      reader.onload = () => {
        const base64String = btoa(String.fromCharCode(...new Uint8Array(reader.result)));

        uploadFiles('post-users-uid', {
          mimeType: file.type,
          fileName: file.type === 'text/plain' ? 'usuarios.txt' : 'usuarios.csv',
          buffer: base64String,
        })
          .then((res) => {
            const response = res.split('/');
            const path = 'post-users-uid/' + response[response.length - 1].split('?')[0];
            resolve(path);
          })
          .catch((err) => {
            reject('');
          });
      };

      reader.onerror = () => {
        reject('');
      };

      reader.readAsArrayBuffer(file);
    });
  };

  // para quando insere usuários por arquivo
  useEffect(() => {
    const readFileContent = async () => {
      if (!file) return;

      try {
        // valida o tipo do arquivo antes de ler
        if (file.type !== 'text/plain' && file.type !== 'text/csv') {
          toast.error('Formato inválido! Use .txt ou .csv.', { autoClose: 2500 });
          setFile(null);
          return;
        }

        // lê o conteúdo do arquivo
        const reader = new FileReader();
        const content = await new Promise((resolve, reject) => {
          reader.onload = (e) => resolve(e.target.result);
          reader.onerror = () => reject(new Error('Falha ao ler o arquivo'));
          reader.readAsText(file);
        });

        // processa os dados
        const dataFile = content
          .split('\n')
          .map((line) => line.trim())
          .filter((line) => line.length > 0);

        if (dataFile.length === 0) {
          toast.error('O arquivo não possui dados válidos.', { autoClose: 2500 });
          setFile(null);
          return;
        }

        // função de validação aprimorada
        const validateLine = (line) => {
          const cleanLine =
            clubKey === 'cellPhone' ||
            clubKey === 'cpf' ||
            clubKey === 'cnpj' ||
            origin === 'establishment'
              ? line.replace(/\D/g, '') // remove tudo que não for número (somente para dados numéricos)
              : line.trim(); // mantém emails sem alterar

          if (origin === 'club') {
            // validação baseada no clubKey
            switch (clubKey) {
              case 'cpf':
                return cleanLine.length === 11 && /^\d{11}$/.test(cleanLine);
              case 'cnpj':
                return cleanLine.length === 14 && /^\d{14}$/.test(cleanLine);
              case 'cellPhone':
                return (
                  cleanLine.startsWith('55') &&
                  cleanLine.length >= 12 &&
                  cleanLine.length <= 13 &&
                  /^55\d{10,11}$/.test(cleanLine)
                );
              case 'email':
                return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(line);
              default:
                return false;
            }
          } else if (origin === 'establishment') {
            // para estabelecimentos, apenas telefones são válidos
            return (
              cleanLine.startsWith('55') &&
              cleanLine.length >= 12 &&
              cleanLine.length <= 13 &&
              /^55\d{10,11}$/.test(cleanLine)
            );
          }

          return false; // caso não se encaixe em nenhuma regra
        };

        // filtra linhas inválidas
        const invalidLines = dataFile.filter((line) => !validateLine(line));

        if (invalidLines.length > 0) {
          toast.error(`${invalidLines.length} dado(s) inválido(s) para o tipo ${clubKey}`, {
            autoClose: 4000,
          });
          setFile(null);
          return;
        }

        // converte os dados para o formato correto
        const formattedData = dataFile.map((line) => ({
          key:
            origin === 'establishment' || clubKey === 'cellPhone'
              ? `+${line.replace(/\D/g, '')}` // telefones
              : line, // CPF, CNPJ e Email mantêm formato original
          name: '--',
          uId: 'Inserido via arquivo',
        }));

        setData((prevData) => [...prevData, ...formattedData]);
        toast.success(`${formattedData.length} usuário(s) adicionado(s) via arquivo.`, {
          autoClose: 2500,
        });
        toast.warning('Usuários repetidos não serão adicionados.', { autoClose: '2500' });
      } catch (error) {
        console.error('Erro na função (readFileContent):', error);
        toast.error('Erro ao processar o arquivo.', { autoClose: 2500 });
        setFile(null);
      }
    };

    readFileContent();
  }, [file, clubKey, origin]);

  // altera o state form, caso o usuário insira informações nos input
  const handleChangeFields = (event) => {
    const { id, value } = event.target;
    setForm((prevForm) => {
      let updatedValue = value;

      if (id === 'notificationDate') {
        updatedValue = new Date(value).getTime();
      }

      return {
        ...prevForm,
        [id]: updatedValue,
      };
    });
  };

  const handleChangeCheckbox = (event) => {
    setCheckedItems({
      ...checkedItems,
      [event.target.name]: event.target.checked,
    });
  };

  // arquivo
  const fileChangedHandler = (event) => {
    if (event.target.files.length !== 0) {
      setFile(event.target.files[0]);

      // reseta o valor do input para permitir a inclusão de um arquivo com o mesmo nome
      event.target.value = null;
    }
  };

  // arquivo
  const handleFileButtonClick = () => {
    document.getElementById('usersList').click();
  };

  // barra de pesquisa da tabela
  const handleSearch = (e) => {
    const term = e.target.value.trim();
    setSearchTerm(term);

    const filtered = data.filter(
      (user) =>
        user.key?.includes(term) ||
        user.uId?.toLowerCase().includes(term) ||
        user.name?.toLowerCase().includes(term)
    );
    setFilteredResults(filtered);
  };

  // adiciona usuário na tabela pelo textField
  const addUser = () => {
    let userToAdd = null;
    let userExists = false;

    if (origin === 'club') {
      userExists = data.some((user) => user.key === token);

      if (userExists) {
        toast.error('Esse usuário já foi adicionado!');
        return;
      }

      const isValidToken =
        (clubKey === 'cellPhone' && token?.length === 14) ||
        (clubKey === 'cpf' && token?.length === 11) ||
        (clubKey === 'cnpj' && token?.length === 14) ||
        (verifyEmail && token.includes('.com'));

      if (!isValidToken) {
        toast.error(`Digite um ${clubKey} válido.`);
        return;
      }

      const usersArray = Array.isArray(dataUsers) ? dataUsers : [dataUsers];

      // busca o usuário pelo token (clubKey) digitado
      userToAdd = usersArray.find((user) => user.key === token);
    } else {
      if (cellPhone.length !== 15) {
        toast.error('Digite um número de celular válido.');
        return;
      }

      const cleanPhone = removeMask(cellPhone);
      const phoneKey = `+55${cleanPhone}`;

      userToAdd = dataUsers.find((user) => user.key === phoneKey);
      userExists = data.some((user) => user.key === phoneKey);

      if (userExists) {
        toast.error('Esse usuário já foi adicionado!');
        return;
      }
    }

    if (userToAdd) {
      setData((prevData) => [...prevData, userToAdd]);
      toast.success('Usuário adicionado à lista.');

      setCellPhone('');
      setCpf('');
      setCnpj('');
      setEmail('');
      setToken('');
      setLoadingValidateUserMapfre(true);
    } else {
      toast.error(
        origin === 'club'
          ? 'Usuário não encontrado.'
          : 'Esse usuário não é um cliente desse estabelecimento.'
      );
    }
  };

  // apaga usuário da tabela
  const deleteUser = (key) => {
    setData((prevData) => prevData.filter((user) => user.key !== key));
    toast.success('Usuário removido da lista.');
  };

  const readFileContent = (fileBlob) => {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (e) => resolve(e.target.result);
      reader.onerror = (err) => reject(err);
      reader.readAsText(fileBlob);
    });
  };

  // envia notificação
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoadingButton(true);

    const emptyFields = [];

    if (!form.notificationDate)
      emptyFields.push('Preencha a data que a notificação será disparada.');
    if (!form.title) emptyFields.push('Preencha o título.');
    if (!form.message) emptyFields.push('Preencha a mensagem.');
    if (form.partnerIdList.length === 0) emptyFields.push('Selecione ao menos um partnerId.');
    if (checkedItems.item2 && data.length === 0)
      emptyFields.push('Para continuar, inclua pelo menos um usuário que receberá a notificação.');
    if (!checkedItems.item1 && !checkedItems.item2)
      setCheckboxMessage('Selecione ao menos uma opção!');

    if (emptyFields.length > 0) {
      emptyFields.forEach((field) => toast.error(field, { autoClose: 2500 }));
      setLoadingButton(false);
      return;
    }

    let fileTxt = null;

    if (arrayDataToTxt) {
      try {
        const path = await uploadingFile(arrayDataToTxt);

        const payload = {
          filePath: path,
          fileFolderName: 'post-users-uid',
          ...(origin === 'establishment' ? { establishmentId } : { partnerId }),
        };

        if (arrayDataToTxt.type === 'text/plain' || arrayDataToTxt.type === 'text/csv') {
          const response = await getUsersByFile(payload);

          if (response.fileOutputPath) {
            const splitIndex = response.fileOutputPath.lastIndexOf('/');
            const filePath = response.fileOutputPath.substring(0, splitIndex);
            const nameFile = response.fileOutputPath.substring(splitIndex + 1);
            // Baixa o arquivo e transforma em URL
            const downloadedFile = await downloadImage(filePath, nameFile);

            if (downloadedFile.startsWith('https')) {
              // Transforma a URL em Blob
              const fileAsBlob = await downloadImageAsBlob(downloadedFile);
              const fileContent = await readFileContent(fileAsBlob);

              const extractedUids = fileContent
                .trim()
                .split('\n')
                .map((line) => line.split(';')[0].trim());

              if (extractedUids.length > 0) {
                const keys = extractedUids.join('\n');
                const blob = new Blob([keys], { type: 'text/plain' });
                const fileAsTxt = new File([blob], 'usuarios.txt', { type: 'text/plain' });

                try {
                  fileTxt = await uploadingFile(fileAsTxt);
                } catch (e) {
                  console.error('Erro ao enviar fileAsTxt:', e);
                }
              }
            }
          }

          if (response.usersNotFound.length > 0) {
            const message =
              origin === 'club'
                ? `Esses usuários não serão notificados, pois não são membros do clube: ${response.usersNotFound.join(
                    ', '
                  )}`
                : `Esses usuários não serão notificados, pois não são clientes desse estabelecimento: ${response.usersNotFound.join(
                    ', '
                  )}`;

            toast.error(message, { autoClose: 2500 });
          }
        } else {
          toast.error('O arquivo precisa ser no formato txt ou csv!', { autoClose: 2500 });
          setArrayDataToTxt(null);
        }
      } catch (error) {
        toast.error('Erro ao fazer upload do arquivo!', { autoClose: 2500 });
      }
    }

    const payload = {
      postId,
      partnerIdList: form.partnerIdList,
      origin: origin === 'club' ? 'seuClube' : 'estabelecimento',
      hasSenderUsers: checkedItems.item1,
      hasListUsers: checkedItems.item2,
      scheduleDate: form.notificationDate,
      notificationTitle: form.title,
      notificationBody: form.message,
      listUsersPath: checkedItems.item2 ? fileTxt : undefined,
    };

    if (checkedItems.item1 && !checkedItems.item2) {
      delete payload.listUsersPath;
    }

    try {
      await createMotherNotification(payload);
      toast.success('Notificação enviada com sucesso', { autoClose: 2500 });
      setTimeout(() => history.goBack(), 2500);
    } catch (e) {
      toast.error('Ocorreu um erro ao tentar enviar a notificação.');
      console.error('Ocorreu um erro:', e);
    } finally {
      setLoadingButton(false);
    }
  };

  const componentReceiver = (column, childrens) => {
    return {
      columnComponent: (
        <>
          <E.TableTH>Excluir</E.TableTH>
        </>
      ),
      childrenComponent:
        childrens === null ? null : (
          <>
            <E.TableTD>
              <ButtonDelete onClick={() => deleteUser(childrens.key)}>
                <DeleteIcon size={10} />
              </ButtonDelete>
            </E.TableTD>
          </>
        ),
    };
  };

  // textfield para adicionar usuarios a lista (clube e estabelecimento)
  const { renderInputByClubKey, renderInputEstablishment } = InputFields({
    cellPhone,
    setCellPhone,
    cpf,
    setCpf,
    cnpj,
    setCnpj,
    email,
    setEmail,
    verifyEmail,
    validateEmail,
    cellPhoneMask,
    cpfMask,
    maskCnpj,
    addUser,
    loadingValidateUserMapfre,
  });

  return (
    <>
      <View
        form={form}
        setForm={setForm}
        handleChangeFields={handleChangeFields}
        handleChangeCheckbox={handleChangeCheckbox}
        checkboxMessage={checkboxMessage}
        checkedItems={checkedItems}
        clubKey={clubKey}
        renderInputByClubKey={renderInputByClubKey}
        renderInputEstablishment={renderInputEstablishment}
        origin={origin}
        errorMessage={errorMessage}
        file={file}
        handleFileButtonClick={handleFileButtonClick}
        fileChangedHandler={fileChangedHandler}
        data={data}
        searchTerm={searchTerm}
        handleSearch={handleSearch}
        filteredResults={filteredResults}
        column={column}
        componentReceiver={componentReceiver}
        loadingButton={loadingButton}
        handleSubmit={handleSubmit}
      />
    </>
  );
}
